module.exports = __webpack_public_path__ + "img/yw_cwjs.27abf765.svg";